import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueWorkflowSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflows-schemes-view',
	path: '/secure/admin/ViewWorkflowSchemes.jspa',
};
